import PageContainer from '@/views/base/page.vue'
export default [
  {
    path: '/index',
    component: PageContainer,
    children: [
      {
        path: '/home',
        component: () => import('@/views/home/index.vue'),
        meta: { title: '首页', keepAlive: true, needAuth: false }
      }
    ]
  }
]
